/**
 * @license
 *
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Main React component that includes the Blockly component.
 * @author samelh@google.com (Sam El-Husseini)
 */

import React from 'react';
import '../App.css';

import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import Header from "../components/NavbarElement";
import Home from './home';
import Level0 from './level0';
import Level1 from './level1';
import Level2 from './level2';
import Playground from './playground';
import Level3 from './level3';
import Level4 from './level4';
import Level5 from './level5';
import Level6 from './level6';
import playground from './playground';

function App(props) {
    return (
      <div className="App">
          <Router>
          <Header />
          <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/level0' element={<Level0 />} />
              <Route path='/level1' element={<Level1 />} />
              <Route path='/level2' element={<Level2 />} />
              <Route path='/level3' element={<Level3 />} />
              <Route path='/level4' element={<Level4 />} />
              <Route path='/level5' element={<Level5 />} />
              <Route path='/level6' element={<Level6 />} />
              <Route path='/playground' element={<Playground />} />
          </Routes>
          </Router>
      </div>
    );
}

export default App;
